<template>
  <div class="app">
    <div class="alert">
      <div class="alert__content">
        <p><span class="alert__emoji">&#128679;</span> This website is still under development, some links or features may not work. We are working hard to bring pv-pa fully functional again soon!</p>
      </div>
    </div>
    <app-navigation></app-navigation>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppNavigation from '@/components/AppNavigation.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  components: {
    AppNavigation,
    AppFooter,
  },
};
</script>

<style lang="scss">
  @import "node_modules/@glidejs/glide/src/assets/sass/glide.core";
  @import "styles/app";

  .alert {
    background-color: $color-primary;

    &__content {
      @extend .container;
      padding: .5rem 0;

      @include breakpoint-down(md) {
        padding: .5rem;
      }

      p {
        margin: 0 auto;
        color: $color-white;
        font-size: .75rem;
        text-align: center;
      }
    }

    &__emoji {
      font-size: 1rem;
    }
  }
</style>
